import React, { createContext, useContext, useMemo, useState } from 'react';

const STORAGE_KEY = 'mediablox-app-mode';

const AppModeContext = createContext(null);

export const AppModeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'agent' ? 'agent' : 'human';
  });

  const setAppMode = (nextMode) => {
    const value = nextMode === 'agent' ? 'agent' : 'human';
    setMode(value);
    localStorage.setItem(STORAGE_KEY, value);
  };

  const value = useMemo(
    () => ({
      mode,
      setAppMode,
      isAgent: mode === 'agent',
    }),
    [mode],
  );

  return <AppModeContext.Provider value={value}>{children}</AppModeContext.Provider>;
};

export const useAppMode = () => {
  const context = useContext(AppModeContext);
  if (!context) {
    throw new Error('useAppMode must be used within AppModeProvider');
  }
  return context;
};
